import { Col, Container, Row } from "react-bootstrap";

import ContactForm from "../components/ContactForm";
import texts from "../texts";
import { Helmet } from "react-helmet";
import { useHreflang } from "../i18n/hooks/useHreflang";

import { getLocaleFromPath } from "../i18n/config";
import { metadataTranslations } from "../i18n/metadata";

// import {Container} from 'react-bootstrap'

const Contact = () => {
    const hreflang = useHreflang("yhteydenotto");
    const locale = getLocaleFromPath();
    const meta = metadataTranslations.contact[locale] || metadataTranslations.contact.fi;

    return (
        <>
            <Helmet>
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
                <link rel="alternate" hrefLang="fi" href={hreflang.fi} />
                <link rel="alternate" hrefLang="en" href={hreflang.en} />
                <link rel="alternate" hrefLang="sv" href={hreflang.sv} />
                <link rel="alternate" hrefLang="x-default" href={hreflang.fi} />
            </Helmet>
            <Container
                fluid
                style={{
                    width: "100vw",
                    backgroundRepeat: "no-repeat",
                    backgroundImage: `url(https://senioritabletti-image-bucket.s3.eu-north-1.amazonaws.com/connect2.jpg)`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "relative",
                    minHeight: 640,
                }}
                className="img-fluid contact-pic"
            >
                <Row>
                    <Col xs={12} lg={7} className="contact-texts-column">
                        <p className="ota-yhteyttä">{texts[8].text1}</p>
                        <p className="apu">{texts[8].text2}</p>
                    </Col>
                    <Col xs={12} lg={5} className="contact-form-column d-lg-block d-none">
                        <ContactForm />
                    </Col>
                </Row>
            </Container>
            <section>
                <div className="d-block d-lg-none">
                    <ContactForm />
                </div>
            </section>
        </>
    );
};

export default Contact;
